<template>
  <div class="container dashboard counselor-dashboard">
    <div v-if="loading" class="row">
      <Loader style="width: 100%;" />
    </div>


    <div v-else-if="!hasSetCalendar" class="row">
      <div class="col-12">
        <div class="welcome-card">
          <div class="row">
            <div class="col-12 col-lg-4 order-lg-2 upper">
              <img class="welcome__img" src="@/assets/img/welcome@2x.png" alt="BetterMynd">
            </div>
            <div class="col-12 col-lg-8 order-lg-1">
              <h1>Welcome back, {{ $store.getters.currentUser.displayName }}!</h1>
              <p>
                In order to start booking appointments, you need to complete your profile by
                adding appointment availability.
              </p>
              <router-link to="/availability" tag="button" class="btn btn-primary btn-wide mt-30">
                Add Availability
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="row">
      <div class="col-12">
        <div class="welcome-card">
          <div class="row">
            <div class="col-12 col-lg-4 order-lg-2 upper">
              <img class="welcome__img" src="@/assets/img/welcome@2x.png" alt="BetterMynd">
            </div>
            <div class="col-12 col-lg-8 order-lg-1">
              <h1>Welcome, {{ $store.getters.currentUser.displayName }}!</h1>
              <div v-if="appointmentRequestCount">
                <p>
                  You’ve got appointment requests that need your approval.
                </p>
                <button type="button" class="btn btn-primary btn-wide pending-btn"
                        @click="showPendingAppointmentRequests()"
                >
                  Review Now
                  <div v-if="appointmentRequestCount" class="count">
                    {{ appointmentRequestCount }}
                  </div>
                </button>
              </div>
              <div v-else-if="isOnVacation">
                <h4>You are on vacation until {{ vacation.end | dateMonthDayOnly }}</h4>
                <p>To extend or prematurely end your vacation, please contact counselors@bettermynd.com.</p>
              </div>
              <div v-else>
                <p>
                  It's good to see you again. You're currently all caught up! Your upcoming
                  appointments will be listed below. Click the "View Clients" button below
                  to schedule follow up appointments with existing patients.
                </p>
                <router-link to="/clients" tag="button" class="btn btn-primary btn-wide mt-30">
                  View Clients
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!loading" class="row">
      <div class="col-12 col-lg-4 welcome-sidebar">
        <!-- <div class="dashboard-card partner-college">
            <div
              class="upper"
              :style="{ backgroundImage: `url(${collegeBackgroundUrl})` }"
            />
            <div
              class="college-avatar"
              :style="{ backgroundImage: `url(${collegeAvatarUrl})` }"
            />
            <div class="mid">
              <table class="table bm-table">
                <tbody>
                  <tr>
                    <td>
                      Total Enrollment
                    </td>
                    <td class="text-right">
                      23,345
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Students using BetterMynd
                    </td>
                    <td class="text-right">
                      1,234
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Other Stat
                    </td>
                    <td class="text-right">
                      57
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div> -->
        <div v-if="!isCounselorAcceptingNewClients" class="dashboard-card highlight-card">
          <h4>You are not accepting new clients at this time.</h4>
          <p>Your existing clients are still able to schedule sessions with you.</p>
          <p>Please contact counselors@bettermynd.com to start receiving requests from new clients.</p>
        </div>
        <div v-if="apptData" class="dashboard-card appointment-chart light">
          <h4>Appointments</h4>
          <div class="chart-holder">
            <column-chart :library="chartOptions" :data="apptData" :colors="['#4cf2f0']" :legend="false"
                          height="100%" width="100%"
            />
          </div>
        </div>
        <div class="dashboard-card no-partner">
          <h4>Availability.</h4>
          <p>Use this to update availability or sync appointments across your calendars.</p>
          <router-link to="/availability" tag="button" class="btn btn-primary btn-wide mt-30">
            Add Availability
          </router-link>
        </div>
      </div>


      <div class="col-12 col-lg-8">
        <session-reminder
          :sessions="scheduledAppointments"
          :workshops="workshops"
        />
        <div v-if="scheduledAppointments.length" class="dashboard-card appt-table">
          <h2>Upcoming Appointments</h2>
          <div class="table-responsive">
            <table class="table bm-table">
              <thead>
                <tr>
                  <th>
                    Student Name
                  </th>
                  <th>Patient Type</th>
                  <th>
                    Date / Time
                  </th>
                  <th />
                </tr>
              </thead>
              <tbody>
                <tr v-for="apt in scheduledAppointments" :key="apt.id">
                  <td v-if="apt.user">
                    <router-link
                      :to="`/student/${apt.user.id}`"
                    >
                      {{ apt.studentDisplayName }}
                    </router-link>
                  </td>
                  <td v-else>Anonymous</td>
                  <td v-if="!apt.existing_patient">New Patient</td>
                  <td v-else>Existing Patient</td>
                  <td>{{ apt.start_time | dateLongMonthNoYear }}</td>
                  <td>
                    <button
                      v-if="apt.start_time > right_now"
                      v-b-tooltip.hover.top="'Reschedule'" type="button"
                      class="fa-btn"
                      @mouseover="update_now()"
                      @click="rescheduleSession(apt)"
                    >
                      <font-awesome-icon :icon="['fas', 'calendar']" class="icon alt" />
                    </button>
                    <button v-b-tooltip.hover.top="'Delete'" type="button" class="fa-btn" @click="cancelApt(apt, true)">
                      <font-awesome-icon :icon="['fas', 'trash']" class="icon alt" />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-if="!hasAppointmentBooked" class="dashboard-card light upcoming-appt">
          <div class="row row-eq-height">
            <h4>Upcoming Appointments</h4>
            <div class="no-results">
              <p>You do not currently have any upcoming appointments.</p>
            </div>
          </div>
        </div>

        <div class="dashboard-card events-table">
          <h2>
            <router-link to="/workshops" tag="a">
              My Wellbeing Workshops
            </router-link>
          </h2>

          <div v-if="!workshops || workshops.length === 0" class="row">
            <div class="col-12">
              <p>You do not have any Wellbeing Workshops yet.</p>
            </div>
          </div>


          <div v-else-if="workshops" class="row">
            <div v-for="workshop in workshops" :key="workshop.id" class="col-12 col-lg-4">
              <div class="event">
                <h4>{{ workshop.topic }}</h4>
                <span class="date">{{ workshop.start_time | date }}</span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="workingHours && workingHours.length" class="dashboard-card appt-table">
          <h2>Weekly Availability</h2>
          <div class="table-responsive">
            <table class="table bm-table">
              <tr v-for="working in workingHours" :key="working.day_of_the_week">
                <td>
                  {{ working.day_of_the_week | capitalize }}s
                </td>
                <td class="text-right">
                  <template v-for="period in working.periods">
                    <span v-if="period.formattedStartTime !== period.formattedEndTime"
                          :key="period.formattedStartTime"
                    >
                      {{ period.formattedStartTime }} - {{ period.formattedEndTime }}<br>
                    </span>
                  </template>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>

    <pending-modal ref="pendingModal" :update-pending-requests-list="updatePendingRequestsList" />

    <confirm-modal ref="confirmModal" title="Cancel Appointment"
                   confirm-body="Are you sure you want to cancel this appointment?" :on-confirm="doCancel" cancel-text="No"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import Chartkick from 'vue-chartkick';
import Chart from 'chart.js';
import PendingModal from '@/components/modals/PendingModal.vue';
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import Loader from '@/components/Loader.vue';

import UserClient from '@/api/UserClient';
import MeetingsClient from '@/api/MeetingsClient';
import CounselorClient from '@/api/CounselorClient';
import WorkshopClient from '@/api/WorkshopClient';
import moment from 'moment-timezone';
import WorkshopView from '@/counselor/workshops/WorkshopView';
import SessionReminder from './components/SessionReminder.vue';

Vue.use(Chartkick.use(Chart));
const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export default {
    name: 'CounselorDashboard',
    components: {
        PendingModal,
        ConfirmModal,
        Loader,
        SessionReminder
    },
    data() {
        return {
            loading: true,
            selectedWorkshop: null,
            userClient: new UserClient(this.$http),
            counselorClient: new CounselorClient(this.$http),
            MeetingsClient: new MeetingsClient(this.$http),
            workshopClient: new WorkshopClient(this.$http),
            workshops: null,

            appointmentRequests: null,
            appointmentRequestCount: 0,

            scheduledAppointments: null,
            upcomingAppointmentCount: 0,

            workingHours: null,

            selectedApt: null,
            right_now: null,

            vacation: {},
            isCounselorAcceptingNewClients: true,

            apptData: null,
            chartOptions: {
                layout: {
                    padding: {
                        left: 10,
                        right: 5,
                        top: 5,
                        bottom: 2,
                    },
                },
                scales: {
                    xAxes: [{
                        display: true,
                        ticks: {
                            fontSize: 10,
                            fontColor: '#c8d2dc',
                        },
                    }],
                    yAxes: [{
                        display: false,
                        ticks: {
                            fontSize: 14,
                            fontColor: '#c8d2dc',
                        },
                    }],
                },
                elements: {
                    point: {
                        radius: 4,
                    },
                },
                defaultFontFamily: "'Playfair Display', Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                defaultFontSize: 30,
                borderWidth: 0,
            },
        };
    },
    asyncComputed: {
        async join_meeting_url() {
            if (!this.scheduledAppointments || !this.scheduledAppointments.length) { return null; }

            const start = moment(this.scheduledAppointments[0].start_time);
            const minutesUntilStart = start.diff(moment(), 'minute');
            if (minutesUntilStart > 15) { return null; }

            return await this.MeetingsClient.join(this.scheduledAppointments[0].meeting_id)
        }
    },
    computed: {
        hasSetCalendar() {
            return this.$store.getters.currentUser && this.$store.getters.currentUser.counselor_profile && this.$store.getters.currentUser.counselor_profile.calendar_initialized;
        },
        hasAppointmentBooked() {
            return this.upcomingAppointmentCount > 0;
        },
        isOnVacation() {
          return this.vacation.start && moment().utc() >= this.vacation.start && moment().utc() < this.vacation.end;
        }
    },
    async mounted() {
        this.update_now();
        if (this.$store.getters.currentUser && (this.$store.getters.currentUser.needsWelcome || (this.$store.getters.currentUser.needsSurvey && !this.$store.getters.currentUser.skippedSurvey))) {
            return this.$router.push({ name: this.$store.getters.currentUser.homeRouteName });
        }

        if (!this.$store.getters.currentUser.counselor_profile.has_set_working_hours) {
            return this.$router.replace({ name: 'availability' });
        }

        try {
            await this.counselorClient.getWorkingHours(this.$store.getters.currentUser.counselor_profile.id).then(res => {
                this.workingHours = res.working_hour_days;

                const local = moment();
                const localOffset = local.utcOffset();

                const tz = moment().tz(res.tzid);
                const workingOffset = tz.utcOffset();

                // offsets in minutes
                const minutesDelta = localOffset - workingOffset;

                this.workingHours.forEach(day => {
                    day.periods.forEach(period => {
                        const startTime = period.start_time;
                        const endTime = period.end_time;

                        const startTimeParts = startTime.split(':');
                        const endTimeParts = endTime.split(':');

                        let startTimeMinutes = (parseInt(startTimeParts[0]) * 60) + parseInt(startTimeParts[1]);
                        let endTimeMinutes = (parseInt(endTimeParts[0]) * 60) + parseInt(endTimeParts[1]);

                        let localStartTimeMinutes = startTimeMinutes + minutesDelta;
                        let localEndTimeMinutes = endTimeMinutes + minutesDelta;

                        if (localStartTimeMinutes < 0) {
                            // todo: we went back to yesterday, so lets assume 00:00 for now.. ?
                            localStartTimeMinutes = 0;
                        }

                        if (localEndTimeMinutes < 0) {
                            // todo: we went back to yesterday, so lets assume 00:00 for now.. ?
                            localEndTimeMinutes = 0;
                        }

                        if (localStartTimeMinutes > 1440) {
                            // todo: we went over to tomorrow.. so lets cap it at 24:00 ...
                            localStartTimeMinutes = 1440;
                        }

                        if (localEndTimeMinutes > 1440) {
                            // todo: we went over to tomorrow.. so lets cap it at 24:00 ...
                            localEndTimeMinutes = 1440;
                        }

                        let startTimeHours = Math.floor(localStartTimeMinutes / 60);
                        let endTimeHours = Math.floor(localEndTimeMinutes / 60);

                        startTimeMinutes = localStartTimeMinutes - (startTimeHours * 60);
                        endTimeMinutes = localEndTimeMinutes - (endTimeHours * 60);

                        const startTimePM = startTimeHours >= 12;
                        const endTimePM = endTimeHours >= 12;

                        if (startTimePM) {
                            startTimeHours -= 12;
                        }

                        if (endTimePM) {
                            endTimeHours -= 12;
                        }

                        if (startTimeHours === 0) {
                            startTimeHours = 12;
                        }

                        if (endTimeHours === 0) {
                            endTimeHours = 12;
                        }

                        period.formattedStartTime = startTimeMinutes ? `${startTimeHours}:${startTimeMinutes} ${startTimePM ? 'PM' : 'AM'}` : `${startTimeHours} ${startTimePM ? 'PM' : 'AM'}`;
                        period.formattedEndTime = endTimeMinutes ? `${endTimeHours}:${endTimeMinutes} ${endTimePM ? 'PM' : 'AM'}` : `${endTimeHours} ${endTimePM ? 'PM' : 'AM'}`;
                    });
                });
            });
        } catch (ex) {
            console.error(ex);
        }

        this.loading = true;
        await this.updatePendingRequestsList();
        await this.getCounselorAcceptingNewClients();
        await this.getCounselorVacation();
        this.loading = false;
    },
    methods: {
        async loadWorkshops() {
            const response = await this.workshopClient.listForCounselor(
                null,
                this.$store.getters.currentUser.counselor_profile.id,
                moment().startOf('day').toISOString(),
                null,
                null,
                ['canceled', 'rejected', 'requested']);

            this.workshops = response.workshops.map(x => new WorkshopView(x));
        },
        async getCounselorVacation() {
          await this.counselorClient.getCounselorVacation(this.$store.getters.currentUser.counselor_profile.id).then(res => {
            if (res.endDate) {
              this.vacation.start = new Date(res.startDate);
              this.vacation.end = new Date(res.endDate);
            }
          }).catch(ex => {
            console.error(ex)
          })
        },
        async getCounselorAcceptingNewClients() {
          await this.counselorClient.getCounselorAcceptingNewClients(this.$store.getters.currentUser.counselor_profile.id).then(res => {
            this.isCounselorAcceptingNewClients = res.acceptingNewClients;
          }).catch(ex => {
            console.error(ex)
          })
        },
        update_now() {
            this.right_now = new Date();
        },
        cancelApt(apt, scheduled) {
            this.selectedApt = apt;
            this.$refs.confirmModal.show();
        },
        doCancel() {
            this.userClient.cancelAppointment(this.selectedApt.id, this.selectedPendingApt).then(() => {
                this.$refs.confirmModal.hide();
                this.$store.commit('setGlobalAlert', {
                    msg: 'Appointment Canceled.',
                });
                this.updatePendingRequestsList();
            }).catch(() => {
                this.$store.commit('setGlobalAlert', {
                    msg: 'Failed to cancel appointment. Please try again!', error: true,
                });
                this.closing = false;
                this.$refs.confirmModal.hide();
            });
        },

        showPendingAppointmentRequests() {
            this.$refs.pendingModal.show(this.appointmentRequests);
        },
        async updatePendingRequestsList() {
            await this.counselorClient.getMyAppointmentRequests(1000).then(res => {
                this.appointmentRequests = res.items || [];
                this.appointmentRequestCount = res.count || 0;
            }).catch(() => {
                this.appointmentRequests = [];
                this.appointmentRequestCount = 0;
            });

            await this.counselorClient.getUpcomingAppointments().then(res => {
                this.scheduledAppointments = res.items || [];
                this.upcomingAppointmentCount = res.count || 0;
            }).catch(() => {
                this.scheduledAppointments = [];
                this.upcomingAppointmentCount = 0;
            });

            await this.loadWorkshops();

            await this.counselorClient.getMyAppointmentsChart().then(res => {
                const monthsReport = res.month_reports || [];

                if (monthsReport.length) {
                    const data = monthsReport.reduce((a, e, i) => {
                        if (i === 0) {
                            return a;
                        }

                        const monthName = monthNames[e.month - 1];
                        const key = monthName.toUpperCase().substring(0, 3);

                        a[key] = e.number_of_appointments || 0;
                        return a;
                    }, {});

                    this.apptData = [{
                        name: 'Appointments',
                        data,
                    }];
                }
            }).catch(ex => {
                console.error(ex);
            });

            if (this.$route.query.show_pending) {
                this.showPendingAppointmentRequests();
            }
        },
        async rescheduleSession(appointment) {
          const data = {
            user: {
              first_name: appointment.user.first_name,
              last_name:  appointment.user.last_name
            },
            start_time: appointment.start_time,
            end_time: appointment.end_time,
            cronofy_event_id: appointment.cronofy_event_id,
            id: appointment.id
          }
          this.$router.push({ path:'/sessions/individual/', query: { data: JSON.stringify(data) } });
        }
    },
};
</script>

<style lang="scss" scoped>
.counselor-dashboard {

  .highlight-card {
    @include blue-gradient;
  }
    .chart-holder {
        position: relative;
        left: -15px;
        width: calc(100% + 15px);
    }
}

.pending-btn {
    white-space: nowrap;
    margin-bottom: 15px;

    @media (min-width: $md-min) {
        margin-top: 7px;
    }

    span,
    .count {
        display: inline-block;
        vertical-align: top;
    }

    .count {
        @include border-radius(200px);

        background: #132940;
        color: $green;
        margin-left: 10px;
        padding-left: 10px;
        padding-right: 10px;
        font-size: 15px;
        line-height: 24px;
        height: 24px;
    }
}

.fa-btn {
    background: none;
    color: white;
    border: none;
    box-shadow: none;
}
</style>
